<template>
  <div
    v-if="versionId"
    class="flex-fill flex flex-column"
    style="overflow-y: auto;"
  >
    <div class="bgc-white flex-auto flex flex-row h-center v-center">
      <h4 style="margin-bottom: 0;">{{ title }}</h4>
    </div>
    <div class="bgc-white flex-auto" style="padding: 0px 15px;">
      <pre class="qaac-description">{{ description }}</pre>
    </div>
    <div class="flex-auto" style="padding: 0px 15px 15px; margin-bottom: 5px;">
      <div style="padding: 5px 15px;">
        提交人：
        <span style="color: #5d9cec;">{{ creatorName }}</span>
      </div>
      <div style="padding: 5px 15px;">提交时间：{{ createdAt }}</div>
      <div style="padding: 5px 15px;">标签：{{ tags }}</div>
    </div>
    <div
      class="flex-fill"
      style="padding: 0px 15px 15px; background-color: #fff;"
    >
      <ul style="padding: 0; list-style: none;">
        <li v-for="item in items" :key="item.order">
          <answer-read-only-item-mobile
            :title="item.title"
            :description="item.description"
            :order="item.order"
            :schema="item.schema"
            :type="item.type"
            :value="item.value"
            :extra="item.extra"
          ></answer-read-only-item-mobile>
        </li>
      </ul>
    </div>
    <div
      class="flex flex-row h-center v-center flex-auto"
      style="padding: 15px;"
    >
      <van-button
        v-if="editPermission"
        type="info"
        block
        @click="goEdit"
        style="margin-right: 15px;"
        >立即修改</van-button
      >
      <van-button v-if="sharePermission" type="info" block @click="showShare"
        >生成二维码</van-button
      >
    </div>
    <share-qrcode-dialog-mobile
      :visible="visible"
      :share-url="shareUrl"
      @on-close="visible = false"
    />
  </div>
  <div
    v-else
    class="bgc-white flex-fill flex flex-column h-center"
    style="height: calc(100% - 15px);"
  >
    <div class="clr-blue" style="font-size: 80px; padding: 24px;">
      <i class="el-icon-warning-outline" />
    </div>
    <h4>很抱歉！您无法查看该收集结果详情</h4>
    <div
      class="flex-fill flex flex-column v-bottom"
      style="width: 100%; padding: 20px;"
    >
      <div class="flex-auto flex flex-row v-center h-center">
        <van-button type="info" block @click="goAnswer"
          >立即填写({{ delay }})</van-button
        >
        <van-button type="info" block @click="goBack">返回</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AnswerReadOnlyItemMobile from "@/components/answer/ReadOnlyItemMobile";
import store from "@/store";
import ErrorHandler from "@/utils/ErrorHandler";
import { Button } from "vant";
import { Icon } from "element-ui";
import ShareQrcodeDialogMobile from "@/components/share/ShareQrcodeDialogMobile";
import { obtainMobileShareUrl } from "@/utils/LinkHelper";

export default {
  name: "readonly-answer",
  components: {
    ShareQrcodeDialogMobile,
    [Icon.name]: Icon,
    [Button.name]: Button,
    AnswerReadOnlyItemMobile,
  },
  computed: {
    ...mapGetters({
      creatorName: "answer/creatorName",
      sourceChannel: "answer/sourceChannel",
      os: "answer/os",
      tags: "answer/tags",
      items: "answer/readonlyItems",
    }),
    ...mapState({
      title: (state) => state.answer.questionnaire.base.title,
      description: (state) => state.answer.questionnaire.base.description,
      uniqueId: (state) => state.answer.current.uniqueId,
      versionId: (state) => state.answer.current.versionId,
      createdAt: (state) => state.answer.current.createdAt,
      editPermission: (state) => {
        const { permission, current } = state.answer;
        return permission.edit && current.editable;
      },
      sharePermission: (state) => state.answer.permission.share,
    }),
  },
  data() {
    return {
      delay: 3,
      interval: null,
      visible: false,
      shareUrl: "",
    };
  },
  methods: {
    ...mapActions({
      obtain: "answer/obtain",
      obtainQuestionnaire: "answer/obtainQuestionnaire",
      checkLogin: "user/checkLogin",
      addShare: "share/add",
    }),
    getValue(index) {
      if (!Array.isArray(this.answerItems)) {
        return "";
      }
      const item = this.answerItems[index];
      if (item) {
        return item.value || "";
      }
      return "";
    },
    goBack() {
      this.$router.push({
        name: "questionnaireStatisticMobile",
        params: { uniqueId: this.uniqueId },
      });
    },
    goEdit() {
      const { answerId } = this.$route.params;
      this.$router.push({
        name: "editAnswerMobile",
        params: { answerId },
      });
    },
    async showShare() {
      const { answerId } = this.$route.params;
      const { uniqueId, success } = await this.addShare({ answerId });
      if (success) {
        this.shareUrl = obtainMobileShareUrl(this.$router.mode, uniqueId);
        this.visible = true;
      }
    },
    goAnswer() {
      this.$router.push({
        name: "answerQuestionnaireMobile",
        params: { uniqueId: this.uniqueId },
      });
    },
  },
  async beforeMount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (!this.versionId) {
      this.interval = setInterval(() => {
        if (this.delay > 0) {
          this.delay -= 1;
        } else {
          this.goAnswer();
        }
      }, 1000);
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const { dispatch, state } = store;
      const allowed = await dispatch("user/checkLogin", {
        followRedirect: true,
      });
      if (allowed) {
        const { answerId } = to.params;
        if (answerId) {
          await dispatch("answer/obtainAnswerPermission", { answerId });
          await dispatch("answer/obtain", { answerId });
          const { uniqueId, versionId } = state.answer.current;
          if (uniqueId && versionId) {
            await dispatch("answer/obtainQuestionnaire", {
              uniqueId,
              versionId,
            });
          } else {
            await dispatch("answer/obtainQuestionnaire", { answerId });
          }
        }
      }
      next();
    } catch (e) {
      ErrorHandler(next)(e);
    }
  },
};
</script>
